import { useState, useEffect } from 'react';
import { fetchCriticas } from '../data/mockData';

export const useCriticas = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const result = await fetchCriticas();
        setData(result);
        
        console.log('Críticas carregadas:', result);
      } catch (err) {
        setError(err);
        console.error('Erro ao carregar críticas:', err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return { data, error, loading };
};
